import React, { useState } from "react";
import DatePicker, { CalendarContainer } from "react-datepicker";

import "react-datepicker/dist/react-datepicker.css";
import { Box, Error, Text } from "atoms";
import { ReactDatePickerStyles } from "./ReactDatePickerStyles";
import MemoCalendar from "assets/icons/Calendar";
import { DateInputBase } from "./DateInputBase";

export const DateInput = ({ error, ...props }) => {
  const MyContainer = ({ className, children }) => {
    return (
      <div>
        <CalendarContainer className={className}>
          <Box>
            <Box textAlign="center" color="neutral.500" fontSize="1.4rem">
              SELECT A DATE
            </Box>
            <Box>{children}</Box>
          </Box>
        </CalendarContainer>
      </div>
    );
  };

  return (
    <DateInputBase>
      {/* <Text as="label"> */}
      <ReactDatePickerStyles>
        <DatePicker
          dateFormat="dd/MM/yyyy"
          calendarContainer={MyContainer}
          shouldCloseOnSelect={true}
          {...props}
        />
      </ReactDatePickerStyles>
      <Box
        position="absolute"
        right="15px"
        className="calendar-icon"
        // {...(disabled ? {} : { cursor: "pointer", onClick: () => setEnabledPicker(() => "DATE") })}
      >
        <MemoCalendar height="1.8rem" width="1.8rem" />
      </Box>
      {error && (
        <Box css={{ pointerEvents: "none" }}>
          <Error text={error} />
        </Box>
      )}
      {/* </Text> */}
    </DateInputBase>
  );
};
